// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import { GoogleMap, Marker } from '@westfieldcorp/google-map-coreoz';
import redMarker from '../../../../img/red-marker.png';
import type { ShoppingCenter } from '../../../../types/shoppingCenterType';
import type { CatchmentAreaElement } from '../../../../types/apolloType';

type Props = {
  apiKey: string,
  shoppingCenter: ShoppingCenter,
  elements: CatchmentAreaElement[],
  nearestRetailerText: React.Node | string,
  isTime: boolean,
  nearestRetailerValue: () => string,
  getNumberOfStoreBetweenDistanceOrTime: (isTime: boolean, elements: CatchmentAreaElement[], minimumTime: number, maximumTime: number) => number,
  numberOfStoreUnderTimeOrDistanceText: (time: number) => React.Node,
  numberOfStoreBetweenTimeOrDistanceText: (minimumTime: number, maximumTime: number) => React.Node,
}
type State = {
  mapIsReady: boolean,
}

class CatchmentAreaMap extends React.Component<Props, State> {
  state = {
    mapIsReady: false,
  };

  render() {
    return (
      <div className="catchment-stores-container">
        {
          this.props.elements
          && this.props.elements.length > 0
            ? (
              <div className="catchment-information-container">
                <div className="catchment-information-column">
                  <div className="catchment-information-text">
                    {this.props.nearestRetailerText}
                    <span className="red-text">
                      {this.props.elements.length}
                    </span>
                  </div>
                  <div className="catchment-information-text">
                    <Translate value="comparator.nearestRetailer" />
                    <span className="red-text">
                      {this.props.nearestRetailerValue()}
                    </span>
                  </div>
                </div>
                <div className="catchment-information-column">
                  <div className="catchment-information-text">
                    <Translate value="comparator.numbersOfRetailersInADistanceLimit" km={5} />
                    <span className="red-text">
                      {this.props.getNumberOfStoreBetweenDistanceOrTime(false, this.props.elements, 0, 5)}
                    </span>
                  </div>
                  <div className="catchment-information-text">
                    {this.props.numberOfStoreUnderTimeOrDistanceText(20)}
                    <span className="red-text">
                      {this.props.getNumberOfStoreBetweenDistanceOrTime(this.props.isTime, this.props.elements, 0, 20)}
                    </span>
                  </div>
                  <div className="catchment-information-text">
                    {this.props.numberOfStoreBetweenTimeOrDistanceText(20, 30)}
                    <span className="red-text">
                      {this.props.getNumberOfStoreBetweenDistanceOrTime(this.props.isTime, this.props.elements, 20, 30)}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <h2>
                <Translate value="comparator.noRetailerFound" />
              </h2>
            )
        }
        <div className="catchment-area-container">
          <GoogleMap
            className="map"
            latitude={Number(this.props.shoppingCenter.latitude)}
            longitude={Number(this.props.shoppingCenter.longitude)}
            zoom={11}
            apiKey={this.props.apiKey}
            googleIsReady={() => this.setState({ mapIsReady: true })}
          >
            {
              this.state.mapIsReady
              && this.props.elements
              && (
                this.props.elements.map(element => (
                  <Marker
                    key={`${element.latitude}${element.longitude}`}
                    title={element.retailerName}
                    position={{
                      lat: element.latitude,
                      lng: element.longitude,
                    }}
                  />
                ))
              )}
            {
              this.state.mapIsReady
              && this.props.elements
              && (
                <Marker
                  key={`${this.props.shoppingCenter.latitude}${this.props.shoppingCenter.longitude}`}
                  title={this.props.shoppingCenter.name}
                  position={{
                    lat: Number(this.props.shoppingCenter.latitude),
                    lng: Number(this.props.shoppingCenter.longitude),
                  }}
                  icon={{
                    url: redMarker,
                    scaledSize: new google.maps.Size(40, 32),
                  }}
                />
              )}
          </GoogleMap>
        </div>
      </div>
    );
  }
}

export default CatchmentAreaMap;
